<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .name -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('edu_courses.name')"
                label-for="input-1"
                ><validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                    :placeholder="$t('edu_courses.name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .description -->
            </b-col>
            <!-- .name -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('edu_courses.name_en')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="newItem.name_en"
                  type="text"
                  :placeholder="$t('edu_courses.name_en')"
                />
              </b-form-group>
              <!-- .description -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('edu_courses.description')"
                label-for="input-2"
              >
                <ckeditor
                  :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                  v-model="newItem.description"
                  :placeholder="$t('edu_courses.description')"
                />
              </b-form-group>
              <!-- .code -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('edu_courses.description_en')"
                label-for="input-2"
              >
                <ckeditor
                  :config="{ contentsLangDirection: 'ltr',versionCheck : false }"
                  v-model="newItem.description_en"
                  :placeholder="$t('edu_courses.description_en')"
                />
              </b-form-group>
              <!-- .code -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-3"
                :label="$t('edu_courses.code')"
                label-for="input-3"
              >
                <b-form-input
                  id="input-3"
                  v-model="newItem.code"
                  type="text"
                  :placeholder="$t('edu_courses.code')"
                />
              </b-form-group>
              <!-- .introductory_file -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('edu_courses.introductory_file')"
                label-for="input-4"
              >
                <b-form-file
                  v-model="newItem.introductory_file"
                  accept="application/pdf"
                  :placeholder="$t('edu_courses.introductory_file')"
                />
              </b-form-group>
              <!-- .flixable -->
            </b-col>
          </b-row>

          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/EduCoursesController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "@validations";
export default {
  name: "EduCoursesForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
